import { WebTracerProvider, BatchSpanProcessor } from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { LoggerProvider, BatchLogRecordProcessor } from '@opentelemetry/sdk-logs';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION, SEMRESATTRS_DEPLOYMENT_ENVIRONMENT } from '@opentelemetry/semantic-conventions';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';

const OTEL_ENDPOINT = 'https://ingest.keeper.pipoline.sk:443';
const OTEL_HEADERS = {'signoz-ingestion-key': '2y2rMoazgiPzL4'};
const OTEL_SERVICE_NAME = 'bazar-web';

export const initTelemetry = () => {
    const resource = resourceFromAttributes({
        [ATTR_SERVICE_NAME]: OTEL_SERVICE_NAME,
        [ATTR_SERVICE_VERSION]: process.env.REACT_APP_VERSION || 'untagged',
        [SEMRESATTRS_DEPLOYMENT_ENVIRONMENT]: process.env.NODE_ENV || 'production',
    });

    const exporter = new OTLPTraceExporter({
        url: `${OTEL_ENDPOINT}/v1/traces`,
        headers: OTEL_HEADERS,
    });

    const provider = new WebTracerProvider({
        resource,
        spanProcessors: [new BatchSpanProcessor(exporter)],
    });

    provider.register({
        contextManager: new ZoneContextManager(),
    });

    // Logs
    const logExporter = new OTLPLogExporter({
        url: `${OTEL_ENDPOINT}/v1/logs`,
        headers: OTEL_HEADERS,
    });
    const loggerProvider = new LoggerProvider({
        resource,
        processors: [new BatchLogRecordProcessor(logExporter)],
    });
    window.__otelLoggerProvider = loggerProvider;

    registerInstrumentations({
        instrumentations: [
            new FetchInstrumentation({
                propagateTraceHeaderCorsUrls: [
                    new RegExp(process.env.REACT_APP_API_URL?.replace(/\/api\/v1$/, '') || ''),
                ],
                clearTimingResources: true,
            }),
            new XMLHttpRequestInstrumentation({
                propagateTraceHeaderCorsUrls: [
                    new RegExp(process.env.REACT_APP_API_URL?.replace(/\/api\/v1$/, '') || ''),
                ],
            }),
            new DocumentLoadInstrumentation(),
        ],
    });
};
